var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", `${ROUTES.analysisConfig.root.match.path}`);
    __publicField(this, "_modulePathname", `${ROUTES.analysisConfig.root.location.pathname}`);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        url: () => `${this.url}`
      },
      list: {
        path: () => `${this.path}${ROUTES.analysisConfig.list.match.path}`,
        url: () => `${this.url}${ROUTES.analysisConfig.list.location.pathname}`
      },
      create: {
        path: () => `${this.path}${ROUTES.analysisConfig.create.match.path}`,
        url: () => `${this.url}${ROUTES.analysisConfig.create.location.pathname}`
      },
      edit: {
        path: () => `${this.path}${ROUTES.analysisConfig.edit.match.path}`,
        url: (configId) => `${this.url}/${configId}${ROUTES.analysisConfig.edit.location.pathname}`
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const AnalysisConfigRouteUtils = new Util();
export {
  AnalysisConfigRouteUtils
};
//# sourceMappingURL=AnalysisConfigRoute.utils.js.map
